module.exports = __webpack_public_path__ + "static/express-530516030e26a09ac38473bd5d8eff0e.svg";